const SUPPRESSED_ENVS = ['stage', 'production'];

export const suppressConsoleInProduction = () => {
  const env = process.env.REACT_APP_ENV;
  if (!SUPPRESSED_ENVS.includes(env ?? '')) return;

  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.info = noop;
  console.debug = noop;
};
